import { TransactionDetailOptionFormType } from '@/features/transaction_items/Detail/type';
import { useTranslation } from '@/i18n';
import { Label } from '@moneyforward/ap-frontend-components';
import classNames from 'classnames';
import { FC, memo, useCallback, useMemo } from 'react';
import { Control } from 'react-hook-form';
import { DebounceFormInput } from './DebounceFormInput';
import styles from './TransactionDetailOptionForm.module.scss';

const cx = classNames.bind(styles);

export type Props = {
  control: Control<TransactionDetailOptionFormType>;
};

export const OptionCode: FC<Props> = memo(({ control }) => {
  const { t } = useTranslation();

  const convertFullWidthToHalfWidth = useCallback((str: string): string => {
    return str.replace(/[０-９]/g, (match) => {
      return String.fromCharCode(match.charCodeAt(0) - 0xfee0);
    });
  }, []);

  const rules = useMemo(
    () => ({
      required: t('required'),
      pattern: {
        value: /^[a-zA-Z0-9\-_]{1,30}$/,
        message: t('transaction_items.detail.options.validation.code'),
      },
      maxLength: {
        value: 30,
        message: t('transaction_items.detail.options.validation.code'),
      },
    }),
    [t]
  );

  return (
    <div className={cx(styles['row'])}>
      <Label htmlFor='code' required>
        <div className={cx(styles['bold'])}>
          {t('transaction_items.detail.options.code')}
        </div>
      </Label>
      <DebounceFormInput
        control={control}
        name='code'
        inputId='code'
        testId='transaction-detail-option-code'
        rules={rules}
        transform={convertFullWidthToHalfWidth}
        debounceMs={2000}
        descriptionMessage={t(
          'transaction_items.detail.options.validation.code'
        )}
      />
    </div>
  );
});
OptionCode.displayName = 'OptionCode';
